import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  CanLoad, Route, UrlSegment
} from '@angular/router';
import { UserService } from './shared/services/user.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url: string = state.url;

    return this.checkLogin(url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route, path: UrlSegment[] = null): boolean {
    const url = `/${route.path}`;

    return this.checkLogin(url, path);
  }

  checkLogin(url: string, path: UrlSegment[] = null): boolean {
    if (url !== null && url.toLowerCase() === "/production-status") {
      return true;
    }

    if (this.userService.isLoggedIn) {
      if (path != null) {
        return this.userService.hasAccess(path);
      }
      else {
        //Note! if no path is specified give access anyway
        return true;
      }
    }

    // Store the attempted URL for redirecting
    // this.authService.redirectUrl = url;

    // Navigate to the login page with extras
    this.router.navigate(['/login']);
    return false;
  }
}
